import type {SVGProps} from 'react'

const SvgCar = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns={'http://www.w3.org/2000/svg'}
    width={24}
    height={24}
    fill={'none'}
    viewBox={'0 0 24 24'}
    {...props}
  >
    <path
      stroke={'currentColor'}
      strokeWidth={1.25}
      d={'M17.125 16.882v-.625H6.875V18a.375.375 0 0 1-.375.375H4A.375.375 0 0 1 3.625 18v-5.5c0-1.036.84-1.875 1.875-1.875h13c1.035 0 1.875.84 1.875 1.875V18a.375.375 0 0 1-.375.375h-2.5a.375.375 0 0 1-.375-.375zM6.387 7.142a1.875 1.875 0 0 1 1.84-1.517h7.546c.897 0 1.669.636 1.84 1.517l.629 3.233H5.758zM6.5 13.5h2M15.5 13.5h2M18.5 10.5l1-1H21M5.5 10.5l-1-1H3'}
    />
  </svg>
)
export default SvgCar
